<template>
<v-dialog v-model="dialogCreatealbums" persistent max-width="500px" max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;{{$t('Dialog.album.headerCreate')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="padding-left: 30px;">
      <div style="height:275px; overflow-y: hidden; margin-top: 10px;">
        <div class="">
          <!-- <v-text-field name="name" label="กรุณากรอกชื่ออัลบั้ม" id="id" v-model="albumsname"></v-text-field> -->
          <input type="text" :placeholder="$t('Dialog.album.nameAlbum')" class="CSChatThai inputnamealbum" v-model="albumsname">
        </div>
        <div>
          <form ref="fileform">
        <v-flex xs12 sm12 md12 xl12  style="" class="containers hidden-sm-and-down listfile">
                <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 10px;" v-if="key < 5">
                  <div style="text-align: right; padding-right: 10px;">
                  <a class="close-classic" @click="removeFile( key )"></a>
                </div>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;padding-left: 10px;padding-right: 10px;">
                    <img class="preview" v-bind:ref="'preview' + parseInt( key )" style="height: 60px !important; width:60px !important;display: flex;justify-content: center;" />
                  </div>
                </div>
                <div  :style="borderinputfile" @click="uppic()" v-if="files.length < 5">

            <v-icon style="color: #757575;">mdi-plus</v-icon>
                  <p style="color: #757575;">
                    {{$t('AnswerQuestion.uploadPhoto')}}
                  </p>
            <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" />

                </div>

              </v-flex>
            </form>

        </div>
      </div>
      <v-layout row wrap justify-center align-center>
        <v-btn dark @click="closeDialog" class="btncancle">
          {{$t('AnswerQuestion.cancel')}}
        </v-btn>
        <v-btn dark @click="createalbums()" v-if="files.length > 0 && albumsname" class="btncreate" :loading="loading">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
        <v-btn v-else disabled class="btncreate">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import { Decode } from '@/services'
var _ = require('lodash')

export default {
  props: { dialogCreatealbums: false, tokenroom: '' },
  data: () => ({
    token: '',
    files: [],
    albumsname: '',
    loading: false,
    borderinputfile: 'text-align:center;border: 1px solid #00000036; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 23px;',
    normal: 'text-align:center; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 23px;',
    dragAndDropCapable: false
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  mounted () {
    this.dragAndDropCapable = this.determineDragAndDropCapable()
    var me =this
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault()
          e.stopPropagation()
        })
      }.bind(this))
      this.$refs.fileform.addEventListener('dragover', function (e) {
        this.borderinputfile = this.normal + 'border: 2px dotted #00000036;'
      }.bind(this))
      this.$refs.fileform.addEventListener('dragleave', function (e) {
        this.borderinputfile = this.normal + 'border: 1px solid #00000036;'
      }.bind(this))
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
          this.getImagePreviews()
          this.borderinputfile = this.normal + 'border: 1px solid #00000036;'
          // }
        }
      }.bind(this))
    }
  },
  methods: {
    determineDragAndDropCapable () {
      var div = document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    },
    uppic () {
      $('#files').click()
    },
    closeDialog () {
      this.files = []
      this.albumsname = ''
      this.$emit('closeCreatealbums', false)
    },
    createalbums () {
      // console.log(this.files)
      let formData = new FormData()
      var lengthfile = this.files.length
      var sizealums = []
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file
        formData.append('file[]', file, file.name)
        // console.log(this.files[i].file.size)
        sizealums[i] = this.files[i].file.size
      }
      // console.log(_.sum(sizealums)/ 1024 / 1024)
      if (_.sum(sizealums)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' })
        this.files = []
        this.loading = false
      } else {
        this.loading = true
        formData.append('tokenuser', this.token)
        formData.append('tokenroom', this.$route.params.roomid)
        formData.append('albums_name', this.albumsname)
        this.axios.post(process.env.APIpub + '/create_album', formData).then((response) => {
          // console.log(response.data.data)
          this.loading = false
          var infoalbums = {}
          infoalbums = response.data.data.albums
          // console.log(infoalbums)
          this.$swal('', this.$t('Alert.Success.createAlbum'), 'success')
          this.$emit('CreateAlbums', response.data.status, infoalbums)
          this.files = []
          this.albumsname = ''
          this.$emit('closeCreatealbums', false)
        }, () => {
          this.loading = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload (key) {
      let uploadedFiles = this.$refs.files.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        })
      }
      this.getImagePreviews(key)
      document.querySelector('#files').value = ''
    },
    removeFile (key) {
      this.files.splice(key, 1)
      this.getImagePreviews(key)
    },
    getImagePreviews (key) {
      console.log('getImagePreviews-----')
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function() {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
          }.bind(this), false)
          reader.readAsDataURL(this.files[i].file)
        } else {
          this.removeFile(i)
          alert(this.$t('Alert.Fail.Album.supportType'))
        }
      }
    }
  },
  watch: {
    files () {
      if (this.files.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.Album.maxFiles'),
          'warning'
        )
        _.pullAt(this.files, [5])
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.btncreate {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #e0e0e0 !important;
  color: black !important;
  text-transform: none;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/albums/CreateAlbumsDialog.vue